import { BaseService } from '../api';
import {
  SUBSCRIPTIONS_V3_BASE_URL,
  SUBSCRIPTIONS_V4_BASE_URL,
} from './constants';

export class LegacySubscriptionService extends BaseService {
  updateLegacySubscription = async (id, subscription) =>
    await this.client.patch(`${SUBSCRIPTIONS_V3_BASE_URL}${id}/`, subscription);

  legacySkipNextDelivery = async id =>
    await this.client.patch(
      `${SUBSCRIPTIONS_V3_BASE_URL}${id}/skip_next_delivery/`,
      {},
    );

  reactivateLegacyPlan = async (id, couponCode, campaignId) =>
    await this.client.put(
      `${SUBSCRIPTIONS_V3_BASE_URL}${id}/activate/${
        campaignId ? `?campaign_id=${campaignId}` : ''
      }`,
      couponCode
        ? {
            coupon_code: couponCode,
          }
        : {},
    );
}
export class SubscriptionService extends BaseService {
  getSubscription = async subscriptionId =>
    await this.client.get(`${SUBSCRIPTIONS_V4_BASE_URL}${subscriptionId}/`);

  updateSubscription = async (subscriptionId, mealPlanInfo) =>
    await this.client.put(
      `${SUBSCRIPTIONS_V4_BASE_URL}${subscriptionId}/`,
      mealPlanInfo,
    );

  skipNextDelivery = async subscriptionId =>
    await this.client.put(
      `${SUBSCRIPTIONS_V4_BASE_URL}${subscriptionId}/skip_next_delivery/`,
      {},
    );

  updateDeliveryDate = async (subscriptionId, nextDeliveryTarget) =>
    await this.client.put(
      `${SUBSCRIPTIONS_V4_BASE_URL}${subscriptionId}/update_delivery_date/`,
      { next_delivery_target: nextDeliveryTarget },
    );

  reactivatePlan = async (subscriptionId, couponCode, campaignId) =>
    await this.client.put(
      `${SUBSCRIPTIONS_V3_BASE_URL}${subscriptionId}/activate/${
        campaignId ? `?campaign_id=${campaignId}` : ''
      }`,
      couponCode
        ? {
            coupon_code: couponCode,
          }
        : {},
    );

  requestPaymentMethodUpdate = async subscriptionId =>
    await this.client.post(
      `${SUBSCRIPTIONS_V4_BASE_URL}${subscriptionId}/update-payment-method/`,
    );
}
